import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { Button, Container, Paper } from "@mui/material";
import { FormInputRadio } from "./FormInputRadio";
import { useForm } from "react-hook-form";
import { Box } from "@mui/system";
import { useCustomerSurveyApiMutation } from "../../../services/apiSlice";
import { useNavigate, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";

export default function CustomerActionNeeded() {
  const [customerSurveyApi, { data, isError, error }] =
    useCustomerSurveyApiMutation();
  const methods = useForm({});
  const { handleSubmit, reset, control, setValue, watch } = methods;

  const [searchParams, setSearchParams] = useSearchParams();
  let jobId = searchParams.get("jobId");
  let UserId = searchParams.get("userId");
  console.log({ searchParams });
  const navigate = useNavigate();
  const onSubmit = async (data) => {
    const jobData = {
      accept_quote: data.accept_quote,
      waiting_for_quote: data.waiting_for_quote,
      withdraw_request: data.withdraw_request,
      jobId: jobId,
      userId: UserId,
    };
    console.log({ data, jobData });
    try {
      const responseData = await customerSurveyApi(jobData).unwrap();
      console.log(
        { responseData },
        "responseData?.message",
        responseData?.message
      );
      if (responseData?.success === true) {
        // success message
        Swal.fire("Awesome!", `  ${responseData?.message}`, "success").then(
          (result) => {
            if (result.isConfirmed || result.isDismissed) {
              navigate(`/dashboard/my-job`);
            }
          }
        );
      } else if (isError) {
        //error
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.data?.message,
        });
      } else if (responseData?.success === false) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.data?.message,
        });
      } else if (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.data?.message,
        });
      } else {
        console.log("error", error?.data?.message);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.data?.message,
        });
      }
    } catch (error) {
      if (isError) {
        //error
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.data?.message,
        });
      } else {
        console.log("error", error?.data?.message);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.data?.message,
        });
      }
    }
  };
  const watchQuote = watch("accept_quote", false);
  const watchQuoteWaiting = watch("waiting_for_quote", false);
  return (
    <Container>
      <Paper
        sx={{
          mx: 5,
          my: 5,
          py: 10,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* <FormControl>
        <FormLabel id="demo-row-radio-buttons-group-label">Gender</FormLabel>
        <RadioGroup
          row
          aria-labelledby="demo-row-radio-buttons-group-label"
          name="row-radio-buttons-group"
        >
          <FormControlLabel value="female" control={<Radio />} label="Female" />
          <FormControlLabel value="male" control={<Radio />} label="Male" />
          <FormControlLabel value="other" control={<Radio />} label="Other" />
        </RadioGroup>
      </FormControl> */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box sx={{ py: 2, px: 4 }}>
            <FormInputRadio
              name={"accept_quote"}
              control={control}
              label={"Did you accept a quote from a Pro?"}
            />
          </Box>{" "}
          {watchQuote === "no" && (
            <Box sx={{ py: 2, px: 4 }}>
              <FormInputRadio
                name={"waiting_for_quote"}
                control={control}
                label={"Are you still waiting for a quote?"}
              />
            </Box>
          )}
          {watchQuoteWaiting === "no" && (
            <Box sx={{ py: 1, mb: 3, px: 4 }}>
              <FormInputRadio
                name={"withdraw_request"}
                control={control}
                label={
                  "Change your mind or other, Do you want to withdraw the service request?"
                }
              />
            </Box>
          )}
          <Button
            variant="contained"
            type="submit"
            className="hover:bg-green-300"
            sx={[
              {
                color: "white",
                //   background: green[600],
                //   width: "40%",
                mx: 30,
                mb: 4,
                px: 2,
                py: 2,
                textAlign: "center",
                placeItems: "center",
              },
              (theme) => ({
                [theme.breakpoints.down("321")]: {
                  // width: "80%",
                  py: 3,
                  px: 1,
                  mx: 1,
                },
              }),
            ]}
          >
            Submit
          </Button>
        </form>
      </Paper>
    </Container>
  );
}
